import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

const element: any = document.getElementById("bfpContainer");
if (element) {
  const module = element.dataset.module || "";
  const version = element.dataset.version || "";

  const root = createRoot(element);
  root.render(
    <React.StrictMode>
      <App module={module} version={version} />
    </React.StrictMode>
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
